/* ============================================================
   Connected apps — the AI agents with access to the account, and how to cut
   one off (docs/mcp.md §7). Plain functions over the ApiClient, shared by the
   Expo and desktop Settings screens so both show the same list and the same
   disconnect.

   Not in the store: this is server-owned state no other device edits and
   nothing offline needs — a list you read when you open the row and a delete
   that must be confirmed by the server, never queued.
   ============================================================ */
import type { ApiClient } from './client';
import type { ServerConnection } from './types';

export async function listConnections(api: ApiClient): Promise<ServerConnection[]> {
  const res = await api.get<{ connections: ServerConnection[] }>('/v1/connections');
  return res.connections;
}

/** Disconnect an agent. Its tokens stop working on its next call; the agent
    will ask the user to sign in again if they want it back. */
export function disconnectConnection(api: ApiClient, clientId: string): Promise<void> {
  return api.del(`/v1/connections/${encodeURIComponent(clientId)}`);
}

/** What to call an agent in the UI when it registered without a name. */
export function connectionLabel(c: Pick<ServerConnection, 'clientName'>): string {
  return c.clientName?.trim() || 'An AI assistant';
}
